import { useEffect } from 'react';
import { useWebSocket } from './websocket';
import Env from 'config/env';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useInferenceSocket = () => {
  const siteId = useSelector(
    (data: RootState) => data?.auth?.profile?.session_site?.id
  );

  const cameraId = useSelector((data: RootState) => data?.cameraLive?.cameraId);

  const socketUrl = siteId
    ? `${Env.WEBSOCKET_URL}/ws/inference/live/${siteId}/${cameraId}`
    : '';

  const { socket, connectionStatus, sendMessage } = useWebSocket(socketUrl);

  useEffect(() => {
    if (socket) {
      socket.addEventListener('message', (event: any) => {
        if (event.data instanceof Blob) {
          return;
        }

        const message = JSON.parse(event.data);
        handleMessageReceived(message);
      });
    }
  }, [socket, cameraId]);

  const handleMessageReceived = (message: any) => {
    const messageType = message?.type;
    const data = message?.data;
  };

  return {
    socket,
    connectionStatus,
    sendMessage
  };
};
